import { useEffect } from 'react';

import { tvpil } from '../compat/tvpil';

type UseSyncWithLastWatchStoreProps = {
  pageReferenceId: string | undefined;
};

export function useSyncWithLastWatchStore({ pageReferenceId }: UseSyncWithLastWatchStoreProps) {
  useEffect(() => {
    // This is needed in order to tell lastWatchedLinearStore to store
    // a last watched linear against correct page reference so it would
    // work as expected on genre pages
    if (pageReferenceId) {
      tvpil.lastWatchedLinearStore.setCurrentHeroRail(pageReferenceId);
    } else {
      tvpil.lastWatchedLinearStore.clearCurrentHeroRail();
    }
  });
}
